import { Box, Dialog, Paper, styled, Typography } from '@mui/material';

export const DialogStyled = styled(Dialog)(({ theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: theme.palette.colors.lockedBackground,
  },
  '& .MuiDialog-paper': {
    backgroundColor: theme.palette.colors.primaryBackground,
  },
}));

export const PaperStyled = styled(Paper)(({ theme }) => ({
  borderRadius: '8px',
  height: '100%',
  [theme.breakpoints.up('xxl')]: {
    height: '90%',
  },
  [theme.breakpoints.up('xxxl')]: {
    height: '80%',
  },
}));

export const OutsidePdfContainer = styled(Box)(({ theme }) => ({
  padding: '12px',
  backgroundColor: theme.palette.colors.primaryBackground,
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  borderBottom: `1px solid ${theme.palette.colors.borderLine}`,
  '&:last-child': {
    borderBottom: 'none',
    borderTop: `1px solid ${theme.palette.colors.borderLine}`,
  },
}));

export const TitleStyled = styled(Typography)(({ theme }) => ({
  fontSize: '17px',
  color: theme.palette.colors.highlight,
}));

export const CheckboxContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '10px',
}));

export const CheckboxText = styled(Typography)(({ theme, disabled }) => ({
  fontSize: '14px',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: disabled
    ? theme.palette.colors.secondaryDisabledText
    : theme.palette.colors.onPrimaryBackground,
  marginLeft: '5px',
}));

export const ButtonsContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
}));
